import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
`

export const GradientArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(90deg, #f8fdeb 0%, #ebfcf4 24%, #eef9fe 68%, #faf4ff 100%);
`

export const BottomArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 0 0px 48px;
  background: linear-gradient(180deg, #4b4b57 20%, #1b1c1d 99.75%);
`
